import { Spinner } from "@ezmid/components-library";

export function PageLoader() {
  return (
    <div className="flex w-full min-w-full justify-center items-center h-screen min-h-screen">
      <Spinner isLoading type="fadeLoader" size="20" color="#38bdf8" />
    </div>
  );
}
